export const australiaPrimaryColor = "#c39b6e"
export const australiaPrimaryColorDarker = "#b5844d" // 15% darker / kangaroo color
